import React from "react";
import "../../resources/css/application.css";
import * as PropTypes from "prop-types";
import iconBulb from "../../resources/images/icon-bulb.svg";


const ErrorAlert = (props) => {

  const {message} = props;

  return (
    <div>
      <div className="alert-info mb-5">
        <img alt={""} className="alert-info__icon" src={iconBulb}/> <p
        className="alert-info__msg">{message}</p>
      </div>
    </div>
  );
};

ErrorAlert.propTypes = {
  message: PropTypes.string
};

export default ErrorAlert;
